var _RFE_module_app_code =
webpackJsonp_RFE_module__name_([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_json3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_promise_polyfill_src_polyfill__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_analytics__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_moduleManager__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_image_enhancer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_optim_events__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader_loader_module__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader_loader_module___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loader_loader_module__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_loader_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_loader_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loader_loader_utils__);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






// to support old module structure


window.RFE = window.RFE || {};
// init optimized events
__WEBPACK_IMPORTED_MODULE_5__helpers_optim_events__["a" /* default */].initGlobal();
// patternlab specific files
if (false) {
    require('../patternlab/conf');
}
// standard modules supporting DOMContentLoaded
__WEBPACK_IMPORTED_MODULE_3__helpers_moduleManager__["a" /* default */].addDependencies([
    {
        dep: ['array_find'],
        test: function () { return !Array.prototype.find; }
    },
    {
        dep: ['nav20_analytics'],
        test: function (context) { return !!context.querySelector('[data-analytics-tales="true"]')
            && !(/[\&\?](previewId|design)=/).test(window.location.href); }
    },
    {
        dep: ['prog_install_prompt']
    },
    {
        dep: ['header'],
        test: function (context) { return !!context.querySelector('.hdr .actions'); }
    },
    {
        dep: ['facebook_api'],
        test: function (context) { return !!context.querySelector('.fbVideoSnippet,.fbVideoSnippetProcessed'); }
    },
    {
        dep: ['youtube_iframe'],
        test: function (context) { return !!context.querySelector('[data-sp_api=\'youtube\']'); }
    },
    {
        dep: ['collapsible'],
        test: function (context) { return !!context.querySelector('.collapsible'); }
    },
    {
        dep: ['switcher'],
        test: function (context) { return !!context.querySelector('[data-switcher-trigger="true"]'); }
    },
    {
        dep: ['scroll_to_link'],
        test: function (context) { return !!context.querySelector('[data-target-id]'); }
    },
    {
        dep: ['highlights', 'hljson_loader'],
        test: function (context) {
            // MilanC: lets try if this should stop from display breaking news in cms iframes
            var isPreview = (/[\&\?](previewId|design)=/).test(window.location.href);
            // const isEmbedded = window.self !== window.top;
            // ^^ bugfix for VOA RESP-4681
            return !!context.querySelector('.c-hlights') && !isPreview && // !isEmbedded &&
                !context.querySelector('#sg-patterns'); // PL Only: exclude from PL libraries
        }
    },
    {
        dep: ['smooth_scroll'],
        test: function (context) { return !!context.querySelector('a[href^="#"]'); }
    },
    {
        dep: ['google_translate'],
        test: function () { return window.self === window.top; } // not for CMS Inline Edit
    },
    {
        dep: ['content_sharing'],
        test: function (context) { return !!context.querySelector('.js-content-sharing'); }
    },
    {
        dep: ['content_sharing_player'],
        test: function (context) { return !!context.querySelector('.js-share--expandable'); }
    },
    {
        dep: ['load_more'],
        test: function (context) { return !!context.querySelector('.link-showMore')
            || !!context.querySelector('.tab-loadContent')
            || !!context.querySelector('.link-ajax')
            || !!context.querySelector('.lazy-scroll-load'); }
    },
    {
        dep: ['content_tabs'],
        test: function (context) { return !!context.querySelector('.js-nav-tabs--content'); }
    },
    {
        dep: ['swipe_slide'],
        test: function (context) { return !!context.querySelector('.swipe-slide'); }
    },
    {
        dep: ['slider_nav_tabs'],
        test: function (context) { return !!context.querySelector('.nav-tabs'); }
    },
    {
        dep: ['carousel'],
        test: function (context) { return !!context.querySelector('.carousel'); }
    },
    {
        dep: ['slider_gallery'],
        test: function (context) { return !!context.querySelector('.js-img-compare'); }
    },
    {
        dep: ['simple_captcha']
    },
    {
        dep: ['validation', 'comments'],
        test: function (context) { return !!context.querySelector('.comments--pangea')
            && !context.querySelector('.news__comments'); }
    },
    {
        dep: ['category_menu'],
        test: function (context) { return !!context.querySelector('.category-menu'); }
    },
    {
        dep: ['analyticstag_event']
    },
    {
        dep: ['flexible_iframe'],
        test: function (context) { return !!context.querySelector('.flexible-iframe'); }
    },
    {
        dep: ['show_single_line'],
        test: function (context) { return !!context.querySelector('.show-single-line'); }
    },
    {
        dep: ['content_floated'],
        test: function (context) { return !!context.querySelector('.content-floated'); }
    },
    {
        dep: ['slider_fred'],
        test: function (context) { return !!context.querySelector('.fredContent__controls'); }
    },
    {
        dep: ['validation', 'poll'],
        test: function (context) { return !!context.querySelector('.poll'); }
    },
    {
        dep: ['validation', 'subscribe'],
        test: function (context) { return !!context.querySelector('.subscribe'); }
    },
    {
        dep: ['validation', 'quiz'],
        test: function (context) { return !!context.querySelector('.quiz'); }
    },
    {
        dep: ['validation', 'login'],
        test: function (context) { return !!context.querySelector('.js-login-box'); }
    },
    {
        // this is now for liberty net only
        dep: ['randomize_bg'],
        test: function (context) { return !!context.querySelector('.pg-login-special'); }
    },
    {
        dep: ['validation', 'register'],
        test: function (context) { return !!context.querySelector('.js-register-form'); }
    },
    {
        dep: ['validation', 'password_recover'],
        test: function (context) { return !!context.querySelector('.js-password-recover-form'); }
    },
    {
        dep: ['validation', 'password_reset'],
        test: function (context) { return !!context.querySelector('.js-password-reset-form'); }
    },
    {
        dep: ['popup_opener'],
        test: function (context) { return !!context.querySelector('.btn-popout-player'); }
    },
    {
        dep: ['whatsapp_share_button']
    },
    {
        dep: [
            'multimedia_player_utils', 'multimedia_player_mpd',
            'multimedia_player_analytics', 'multimedia_player_core', 'multimedia_player_ui'
        ],
        test: function (context) {
            return !!context.querySelector('.c-mmp') ||
                !!context.querySelector('.quiz') ||
                !!context.querySelector('.pg-liveblog');
        }
    },
    {
        dep: ['sticky_player_pangea_video'],
        test: function (context) { return !!context.querySelector('[data-sp_api=\'pangea-video\']')
            && !isPreviewPage; }
    },
    {
        dep: ['sticky_player_youtube'],
        test: function (context) { return !!context.querySelector('[data-sp_api=\'youtube\']')
            && !isPreviewPage; }
    },
    {
        dep: ['playlist'],
        test: function (context) { return !!context.querySelector('.playlist'); }
    },
    {
        dep: ['sticky_player_history_handler'],
        test: function () { return !!window.history
            && !isPreviewPage; }
    },
    {
        dep: ['sticky_player'],
        test: function (context) { return !!context.querySelector('[data-sp_api]')
            && !isPreviewPage; }
    },
    {
        dep: ['validation', 'ugc'],
        test: function (context) { return !!context.querySelector('.js-ugc-box'); }
    },
    {
        dep: ['copy_to_clipboard']
    },
    {
        dep: ['slide_in_widget'],
        test: function (context) { return !!context.querySelector('.slide-in-wg'); }
    },
    {
        dep: ['calendar'],
        test: function (context) { return !!context.querySelector('.calendar'); }
    },
    {
        dep: ['editorial_bar'],
        test: function () {
            var bar_data = window.bar_data;
            var isLoggedIn = (typeof bar_data !== 'undefined') &&
                (typeof bar_data.cookieName !== 'undefined') &&
                (RFE.readCookie(bar_data.cookieName));
            var isPreview = (/[\&\?](previewId|design)=/).test(window.location.href);
            var isEmbedded = ((typeof bar_data !== 'undefined') &&
                bar_data.isEmbedded &&
                bar_data.isEmbedded !== '0') ||
                window.self !== window.top;
            return !!isLoggedIn && !isPreview && !isEmbedded;
        }
    },
    {
        dep: ['widget_switcher'],
        test: function (context) { return !!context.querySelector('.js-widget-switcher'); }
    },
    {
        dep: ['captcha_form_helper'],
        test: function (context) { return !!context.querySelector('.captcha-show'); }
    },
    {
        dep: ['graphic_content'],
        test: function (context) { return !!context.querySelector('.content-advisory'); }
    },
    {
        dep: ['image_expander'],
        test: function (context) { return !!context.querySelector('.c-lightbox'); }
    },
    {
        dep: ['sticky_btn_panel'],
        test: function (context) { return (!!context.querySelector('.sticky-btn')
            || (!!context.querySelector('.sticky-panel') && (typeof CSS === 'undefined' || !CSS.supports('position', 'sticky'))))
            && !isPreviewPage; }
    },
    {
        dep: ['accordeon'],
        test: function (context) { return !!context.querySelector('.accordeon'); }
    },
    {
        dep: ['share_link'],
        test: function (context) { return !!context.querySelector('.ctc'); }
    },
    {
        dep: ['combobox_helper'],
        test: function (context) { return !!context.querySelector('.dropdown'); }
    },
    {
        dep: ['date_picker'],
        test: function (context) { return !!context.querySelector('.form__date-picker'); }
    },
    {
        dep: ['tags'],
        test: function (context) { return !!context.querySelector('.tags'); }
    },
    {
        dep: ['livepage'],
        test: function (context) { return !!context.querySelector('.livepage'); }
    },
    {
        dep: ['search_page'],
        test: function (context) { return !!context.querySelector('.pg-srch'); }
    },
    {
        dep: ['video_enhancer'],
        test: function (context) { return !!context.querySelector('.video'); }
    },
    {
        dep: ['sharing_open'],
        test: function (context) { return !!context.querySelector('.share__item'); }
    },
    {
        dep: ['comments_load_more'],
        test: function (context) { return !!context.querySelector('.btn--load-more-comments'); }
    },
    {
        dep: ['comment_pangea'],
        test: function (context) { return !!context.querySelector('.comment--pangea'); }
    },
    {
        dep: ['comments_fb'],
        test: function (context) { return !!context.querySelector('.comments--fb'); }
    },
    {
        dep: ['async_loaded_player'],
        test: function (context) { return !!context.querySelector('.aslp'); }
    },
    {
        dep: ['podcast_wg'],
        test: function (context) { return !!context.querySelector('.podcast-wg'); }
    },
    {
        dep: ['podcast_sub'],
        test: function (context) { return !!context.querySelector('.podcast-sub'); }
    },
    {
        dep: ['non_form_sys_msg'],
        test: function (context) { return !!context.querySelector('.calendar-component .sys-msg'); }
    },
    {
        dep: ['transition_toggler'],
        test: function (context) { return !!context.querySelector('.trans-target'); }
    },
    {
        dep: ['nav20'],
        test: function (context) { return !!context.querySelector('.hdr-20'); }
    },
    {
        dep: ['chapter_nav'],
        test: function (context) { return !!context.querySelector('.sticky-share-container .pg-title') && !!context.querySelector('[data-create-chapter=true]'); }
    },
    {
        dep: ['live_b_drop'],
        test: function (context) { return !!context.querySelector('.live-b-drop')
            && window.location.href.indexOf('patternlab') === -1
            && !(/[\&\?](previewId|design)=/).test(window.location.href); }
    },
    {
        dep: ['sticky_sharing20'],
        test: function (context) { return !!context.querySelector('.content-sharing--sticky .content-sharing__list')
            && !!context.querySelector('.hdr-20'); }
    },
    {
        dep: ['news_layout'],
        test: function (context) { return !!context.querySelector('#newsItems'); }
    },
    {
        dep: ['live_blog_page_notification'],
        test: function (context) { return !!context.querySelector('.update-liveblog')
            && !isPreviewPage; }
    },
    {
        dep: ['feature_story_share_conflict'],
        test: function (context) { return !!context.querySelector('.fa-container .wsw__embed--jumbo,.fa-container .wsw__embed--fullwidth'); }
    },
    {
        dep: ['inline_note'],
        test: function (context) { return !!context.querySelector('.inline-note'); }
    }
]);
// modules which need full page load
__WEBPACK_IMPORTED_MODULE_3__helpers_moduleManager__["a" /* default */].addDependencies([
    {
        dep: ['facebook_video_snippet', 'sticky_player_facebook'],
        test: function (context) { return !!context.querySelector('[data-sp_api=\'facebook\']')
            && !isPreviewPage; }
    },
    {
        dep: ['scroll_to_id'],
        test: function (context) { return !!context.querySelector('#entry-shared'); }
    },
    {
        dep: ['custom_print'],
        test: function (context) { return !!context.querySelector('.print-dialogue'); }
    }
], 'pageFullLoad');
// modules which needs to be re-initialized on Quiz update
// this part should be loaded later as moduleManager.trigger('updateHtml', document.body)
__WEBPACK_IMPORTED_MODULE_3__helpers_moduleManager__["a" /* default */].addDependencies([
    {
        // html5 player can be dynamically loaded by AJAX POST request in form submit handler in Quiz
        dep: [
            'multimedia_player_utils', 'multimedia_player_mpd',
            'multimedia_player_analytics', 'multimedia_player_core', 'multimedia_player_ui'
        ],
        test: function (context) { return !!context.querySelector('.c-mmp'); }
    },
    {
        dep: ['simple_captcha']
    },
    {
        dep: ['popup_opener'],
        test: function (context) { return !!context.querySelector('.btn-popout-player'); }
    },
    {
        dep: ['content_sharing'],
        test: function (context) { return !!context.querySelector('.js-content-sharing'); }
    },
    {
        dep: ['content_sharing_player'],
        test: function (context) { return !!context.querySelector('.js-share--expandable'); }
    },
    {
        dep: ['swipe_slide'],
        test: function (context) { return !!context.querySelector('.swipe-slide'); }
    },
    {
        dep: ['validation', 'quiz'],
        test: function (context) { return !!context.querySelector('.quiz'); }
    },
    {
        dep: ['smooth_scroll'],
        test: function (context) { return !!context.querySelector('a[href^="#"]'); }
    },
    {
        dep: ['image_expander'],
        test: function (context) { return !!context.querySelector('.c-lightbox'); }
    },
    {
        dep: ['slider_gallery'],
        test: function (context) { return !!context.querySelector('.js-img-compare'); }
    },
    {
        dep: ['load_more'],
        test: function (context) { return !!context.querySelector('.link-showMore')
            || !!context.querySelector('.tab-loadContent')
            || !!context.querySelector('.link-ajax')
            || !!context.querySelector('.lazy-scroll-load'); }
    },
    {
        dep: ['graphic_content'],
        test: function (context) { return !!context.querySelector('.content-advisory'); }
    },
    {
        dep: ['switcher'],
        test: function (context) { return !!context.querySelector('[data-switcher-trigger="true"]'); }
    },
    {
        dep: ['accordeon'],
        test: function (context) { return !!context.querySelector('.accordeon__item'); }
    },
    {
        dep: ['news_layout'],
        test: function (context) { return !!context.querySelector('#newsItems'); }
    },
    {
        dep: ['sticky_btn_panel'],
        test: function (context) { return (!!context.querySelector('.sticky-btn')
            || (!!context.querySelector('.sticky-panel') && (typeof CSS === 'undefined' || !CSS.supports('position', 'sticky'))))
            && !isPreviewPage; }
    },
    {
        dep: ['share_link'],
        test: function (context) { return !!context.querySelector('.ctc'); }
    },
    {
        dep: ['validation', 'comments'],
        test: function (context) { return !!context.querySelector('.comments--pangea')
            && !context.querySelector('.news__comments'); }
    },
    {
        dep: ['content_floated'],
        test: function (context) { return !!context.querySelector('.content-floated'); }
    },
    {
        dep: ['combobox_helper'],
        test: function (context) { return !!context.querySelector('.dropdown'); }
    },
    {
        dep: ['slider_nav_tabs'],
        test: function (context) { return !!context.querySelector('.nav-tabs'); }
    },
    {
        dep: ['video_enhancer'],
        test: function (context) { return !!context.querySelector('.video'); }
    },
    {
        dep: ['sharing_open'],
        test: function (context) { return !!context.querySelector('.share__item'); }
    },
    {
        dep: ['flexible_iframe'],
        test: function (context) { return !!context.querySelector('.flexible-iframe'); }
    },
    {
        dep: ['comments_load_more'],
        test: function (context) { return !!context.querySelector('.btn--load-more-comments'); }
    },
    {
        dep: ['comment_pangea'],
        test: function (context) { return !!context.querySelector('.comment--pangea'); }
    },
    {
        dep: ['validation', 'subscribe'],
        test: function (context) { return !!context.querySelector('.subscribe'); }
    },
    {
        dep: ['validation', 'poll'],
        test: function (context) { return !!context.querySelector('.poll'); }
    },
    {
        dep: ['async_loaded_player'],
        test: function (context) { return !!context.querySelector('.aslp'); }
    },
    {
        dep: ['podcast_wg'],
        test: function (context) { return !!context.querySelector('.podcast-wg'); }
    },
    {
        dep: ['podcast_sub'],
        test: function (context) { return !!context.querySelector('.podcast-sub'); }
    },
    {
        dep: ['non_form_sys_msg'],
        test: function (context) { return !!context.querySelector('.calendar-component .sys-msg'); }
    },
    {
        dep: ['sticky_player_pangea_video'],
        test: function (context) { return !!context.querySelector('[data-sp_api=\'pangea-video\']')
            && RFE.stickyPlayers === undefined
            && !isPreviewPage; }
    },
    {
        dep: ['sticky_player_youtube'],
        test: function (context) { return !!context.querySelector('[data-sp_api=\'youtube\']')
            && RFE.stickyPlayers === undefined
            && !isPreviewPage; }
    },
    {
        dep: ['sticky_player_history_handler'],
        test: function () { return !!window.history
            && RFE.stickyPlayers === undefined
            && !isPreviewPage; }
    },
    {
        dep: ['sticky_player'],
        test: function (context) { return !!context.querySelector('[data-sp_api]')
            && RFE.stickyPlayers === undefined
            && !isPreviewPage; }
    },
    {
        dep: ['slider_fred'],
        test: function (context) { return !!context.querySelector('.fredContent__controls'); }
    },
    {
        dep: ['live_blog_page_notification'],
        test: function (context) { return !!context.querySelector('.update-liveblog')
            && !isPreviewPage; }
    },
    {
        dep: ['feature_story_share_conflict'],
        test: function (context) { return !!context.querySelector('.fa-container .wsw__embed--jumbo,.fa-container .wsw__embed--fullwidth'); }
    },
    {
        dep: ['inline_note'],
        test: function (context) { return !!context.querySelector('.inline-note'); }
    }
], 'updateHtml');
// modules that need to be re-initialized when lightbox opens and has intro
// this phase is triggered after lightbox intro contents are finished and just for that intro
__WEBPACK_IMPORTED_MODULE_3__helpers_moduleManager__["a" /* default */].addDependencies([
    {
        dep: ['content_sharing'],
        test: function (context) { return !!context.querySelector('.js-content-sharing'); }
    },
    {
        dep: ['content_sharing_player'],
        test: function (context) { return !!context.querySelector('.js-share--expandable'); }
    },
    {
        dep: ['share_link'],
        test: function (context) { return !!context.querySelector('.ctc'); }
    },
    {
        dep: ['graphic_content'],
        test: function (context) { return !!context.querySelector('.content-advisory'); }
    },
    {
        dep: ['inline_note'],
        test: function (context) { return !!context.querySelector('.inline-note'); }
    }
], 'lightbox');
// this phase is triggered when showing comments on news layout
__WEBPACK_IMPORTED_MODULE_3__helpers_moduleManager__["a" /* default */].addDependencies([
    {
        dep: ['validation', 'comments'],
        test: function (context) { return !!context.querySelector('.comments-parent'); }
    },
    {
        dep: ['sticky_btn_panel'],
        test: function (context) { return !!context.querySelector('.sticky-btn') && !isPreviewPage; }
    }
], 'newslayoutComments');
var contentLoaded = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // init image enhancer
                __WEBPACK_IMPORTED_MODULE_4__helpers_image_enhancer__["a" /* default */].initGlobal();
                // init optimized events
                __WEBPACK_IMPORTED_MODULE_5__helpers_optim_events__["a" /* default */].initGlobal();
                // set the default context for the loader
                window.defaultLoaderContext = document.documentElement;
                // initialize modules
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_3__helpers_moduleManager__["a" /* default */].init(window.defaultLoaderContext)];
            case 1:
                // initialize modules
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
if (document.readyState === 'loading') {
    // standard modules supporting DOMContentLoaded
    window.addEventListener('DOMContentLoaded', function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            contentLoaded();
            return [2 /*return*/];
        });
    }); });
}
else {
    // somehow DOMContentLoaded already happened and we didn't listen
    contentLoaded();
}
// modules which need full page load
window.addEventListener('load', function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        // set the default context for the loader
        window.defaultLoaderContext = document.documentElement;
        __WEBPACK_IMPORTED_MODULE_3__helpers_moduleManager__["a" /* default */].trigger('pageFullLoad', window.defaultLoaderContext);
        return [2 /*return*/];
    });
}); });
window.addEventListener('pageshow', function (event) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (event.persisted) {
            // page is reloaded from Back/Forward Cache (bfcache) (by using system navigation)
            window.defaultLoaderContext = document.documentElement;
            __WEBPACK_IMPORTED_MODULE_3__helpers_moduleManager__["a" /* default */].trigger('pageFullLoad', window.defaultLoaderContext);
        }
        return [2 /*return*/];
    });
}); });
window.addEventListener('beforeunload', function () {
    // deinit image enhancer
    __WEBPACK_IMPORTED_MODULE_4__helpers_image_enhancer__["a" /* default */].deinitGlobal();
    // deinit optimized events;
    __WEBPACK_IMPORTED_MODULE_5__helpers_optim_events__["a" /* default */].deinitGlobal();
});
window.moduleManager = __WEBPACK_IMPORTED_MODULE_3__helpers_moduleManager__["a" /* default */];
// analytics
window.getAnalyticsPageData = __WEBPACK_IMPORTED_MODULE_2__helpers_analytics__["g" /* getAnalyticsPageData */];
window.trackAnalyticsEvent = __WEBPACK_IMPORTED_MODULE_2__helpers_analytics__["h" /* trackAnalyticsEvent */];
window.trackAnalyticsView = __WEBPACK_IMPORTED_MODULE_2__helpers_analytics__["i" /* trackAnalyticsView */];
window.FireAnalyticsTagEventOnDownload = __WEBPACK_IMPORTED_MODULE_2__helpers_analytics__["a" /* FireAnalyticsTagEventOnDownload */];
window.FireAnalyticsTagEventOnSearch = __WEBPACK_IMPORTED_MODULE_2__helpers_analytics__["b" /* FireAnalyticsTagEventOnSearch */];
window.FireAnalyticsTagEventOnSearchResultItemClick = __WEBPACK_IMPORTED_MODULE_2__helpers_analytics__["c" /* FireAnalyticsTagEventOnSearchResultItemClick */];
window.FireAnalyticsTagEventQuiz = __WEBPACK_IMPORTED_MODULE_2__helpers_analytics__["d" /* FireAnalyticsTagEventQuiz */];
window.FireTealiumEvent = __WEBPACK_IMPORTED_MODULE_2__helpers_analytics__["e" /* FireTealiumEvent */];
window.FireTealiumEventOnDownload = __WEBPACK_IMPORTED_MODULE_2__helpers_analytics__["f" /* FireTealiumEventOnDownload */];


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! JSON v3.3.2 | https://bestiejs.github.io/json3 | Copyright 2012-2015, Kit Cambridge, Benjamin Tan | http://kit.mit-license.org */
;(function () {
  // Detect the `define` function exposed by asynchronous module loaders. The
  // strict `define` check is necessary for compatibility with `r.js`.
  var isLoader = "function" === "function" && __webpack_require__(12);

  // A set of types used to distinguish objects from primitives.
  var objectTypes = {
    "function": true,
    "object": true
  };

  // Detect the `exports` object exposed by CommonJS implementations.
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  // Use the `global` object exposed by Node (including Browserify via
  // `insert-module-globals`), Narwhal, and Ringo as the default context,
  // and the `window` object in browsers. Rhino exports a `global` function
  // instead.
  var root = objectTypes[typeof window] && window || this,
      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;

  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
    root = freeGlobal;
  }

  // Public: Initializes JSON 3 using the given `context` object, attaching the
  // `stringify` and `parse` functions to the specified `exports` object.
  function runInContext(context, exports) {
    context || (context = root.Object());
    exports || (exports = root.Object());

    // Native constructor aliases.
    var Number = context.Number || root.Number,
        String = context.String || root.String,
        Object = context.Object || root.Object,
        Date = context.Date || root.Date,
        SyntaxError = context.SyntaxError || root.SyntaxError,
        TypeError = context.TypeError || root.TypeError,
        Math = context.Math || root.Math,
        nativeJSON = context.JSON || root.JSON;

    // Delegate to the native `stringify` and `parse` implementations.
    if (typeof nativeJSON == "object" && nativeJSON) {
      exports.stringify = nativeJSON.stringify;
      exports.parse = nativeJSON.parse;
    }

    // Convenience aliases.
    var objectProto = Object.prototype,
        getClass = objectProto.toString,
        isProperty = objectProto.hasOwnProperty,
        undefined;

    // Internal: Contains `try...catch` logic used by other functions.
    // This prevents other functions from being deoptimized.
    function attempt(func, errorFunc) {
      try {
        func();
      } catch (exception) {
        if (errorFunc) {
          errorFunc();
        }
      }
    }

    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
    var isExtended = new Date(-3509827334573292);
    attempt(function () {
      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
      // results for certain dates in Opera >= 10.53.
      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
    });

    // Internal: Determines whether the native `JSON.stringify` and `parse`
    // implementations are spec-compliant. Based on work by Ken Snyder.
    function has(name) {
      if (has[name] != null) {
        // Return cached feature test result.
        return has[name];
      }
      var isSupported;
      if (name == "bug-string-char-index") {
        // IE <= 7 doesn't support accessing string characters using square
        // bracket notation. IE 8 only supports this for primitives.
        isSupported = "a"[0] != "a";
      } else if (name == "json") {
        // Indicates whether both `JSON.stringify` and `JSON.parse` are
        // supported.
        isSupported = has("json-stringify") && has("date-serialization") && has("json-parse");
      } else if (name == "date-serialization") {
        // Indicates whether `Date`s can be serialized accurately by `JSON.stringify`.
        isSupported = has("json-stringify") && isExtended;
        if (isSupported) {
          var stringify = exports.stringify;
          attempt(function () {
            isSupported =
              // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
              // serialize extended years.
              stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
              // The milliseconds are optional in ES 5, but required in 5.1.
              stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
              // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
              // four-digit years instead of six-digit years. Credits: @Yaffle.
              stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
              // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
              // values less than 1000. Credits: @Yaffle.
              stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
          });
        }
      } else {
        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
        // Test `JSON.stringify`.
        if (name == "json-stringify") {
          var stringify = exports.stringify, stringifySupported = typeof stringify == "function";
          if (stringifySupported) {
            // A test function object with a custom `toJSON` method.
            (value = function () {
              return 1;
            }).toJSON = value;
            attempt(function () {
              stringifySupported =
                // Firefox 3.1b1 and b2 serialize string, number, and boolean
                // primitives as object literals.
                stringify(0) === "0" &&
                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
                // literals.
                stringify(new Number()) === "0" &&
                stringify(new String()) == '""' &&
                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
                // does not define a canonical JSON representation (this applies to
                // objects with `toJSON` properties as well, *unless* they are nested
                // within an object or array).
                stringify(getClass) === undefined &&
                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
                // FF 3.1b3 pass this test.
                stringify(undefined) === undefined &&
                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
                // respectively, if the value is omitted entirely.
                stringify() === undefined &&
                // FF 3.1b1, 2 throw an error if the given value is not a number,
                // string, array, object, Boolean, or `null` literal. This applies to
                // objects with custom `toJSON` methods as well, unless they are nested
                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
                // methods entirely.
                stringify(value) === "1" &&
                stringify([value]) == "[1]" &&
                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
                // `"[null]"`.
                stringify([undefined]) == "[null]" &&
                // YUI 3.0.0b1 fails to serialize `null` literals.
                stringify(null) == "null" &&
                // FF 3.1b1, 2 halts serialization if an array contains a function:
                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
                // elides non-JSON values from objects and arrays, unless they
                // define custom `toJSON` methods.
                stringify([undefined, getClass, null]) == "[null,null,null]" &&
                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
                // where character escape codes are expected (e.g., `\b` => `\u0008`).
                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
                stringify(null, value) === "1" &&
                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]";
            }, function () {
              stringifySupported = false;
            });
          }
          isSupported = stringifySupported;
        }
        // Test `JSON.parse`.
        if (name == "json-parse") {
          var parse = exports.parse, parseSupported;
          if (typeof parse == "function") {
            attempt(function () {
              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
              // Conforming implementations should also coerce the initial argument to
              // a string prior to parsing.
              if (parse("0") === 0 && !parse(false)) {
                // Simple parsing test.
                value = parse(serialized);
                parseSupported = value["a"].length == 5 && value["a"][0] === 1;
                if (parseSupported) {
                  attempt(function () {
                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
                    parseSupported = !parse('"\t"');
                  });
                  if (parseSupported) {
                    attempt(function () {
                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
                      // certain octal literals.
                      parseSupported = parse("01") !== 1;
                    });
                  }
                  if (parseSupported) {
                    attempt(function () {
                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
                      // points. These environments, along with FF 3.1b1 and 2,
                      // also allow trailing commas in JSON objects and arrays.
                      parseSupported = parse("1.") !== 1;
                    });
                  }
                }
              }
            }, function () {
              parseSupported = false;
            });
          }
          isSupported = parseSupported;
        }
      }
      return has[name] = !!isSupported;
    }
    has["bug-string-char-index"] = has["date-serialization"] = has["json"] = has["json-stringify"] = has["json-parse"] = null;

    if (!has("json")) {
      // Common `[[Class]]` name aliases.
      var functionClass = "[object Function]",
          dateClass = "[object Date]",
          numberClass = "[object Number]",
          stringClass = "[object String]",
          arrayClass = "[object Array]",
          booleanClass = "[object Boolean]";

      // Detect incomplete support for accessing string characters by index.
      var charIndexBuggy = has("bug-string-char-index");

      // Internal: Normalizes the `for...in` iteration algorithm across
      // environments. Each enumerated key is yielded to a `callback` function.
      var forOwn = function (object, callback) {
        var size = 0, Properties, dontEnums, property;

        // Tests for bugs in the current environment's `for...in` algorithm. The
        // `valueOf` property inherits the non-enumerable flag from
        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
        (Properties = function () {
          this.valueOf = 0;
        }).prototype.valueOf = 0;

        // Iterate over a new instance of the `Properties` class.
        dontEnums = new Properties();
        for (property in dontEnums) {
          // Ignore all properties inherited from `Object.prototype`.
          if (isProperty.call(dontEnums, property)) {
            size++;
          }
        }
        Properties = dontEnums = null;

        // Normalize the iteration algorithm.
        if (!size) {
          // A list of non-enumerable properties inherited from `Object.prototype`.
          dontEnums = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
          // properties.
          forOwn = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, length;
            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
            for (property in object) {
              // Gecko <= 1.0 enumerates the `prototype` property of functions under
              // certain conditions; IE does not.
              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
                callback(property);
              }
            }
            // Manually invoke the callback for each non-enumerable property.
            for (length = dontEnums.length; property = dontEnums[--length];) {
              if (hasProperty.call(object, property)) {
                callback(property);
              }
            }
          };
        } else {
          // No bugs detected; use the standard `for...in` algorithm.
          forOwn = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
            for (property in object) {
              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
                callback(property);
              }
            }
            // Manually invoke the callback for the `constructor` property due to
            // cross-environment inconsistencies.
            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
              callback(property);
            }
          };
        }
        return forOwn(object, callback);
      };

      // Public: Serializes a JavaScript `value` as a JSON string. The optional
      // `filter` argument may specify either a function that alters how object and
      // array members are serialized, or an array of strings and numbers that
      // indicates which properties should be serialized. The optional `width`
      // argument may be either a string or number that specifies the indentation
      // level of the output.
      if (!has("json-stringify") && !has("date-serialization")) {
        // Internal: A map of control characters and their escaped equivalents.
        var Escapes = {
          92: "\\\\",
          34: '\\"',
          8: "\\b",
          12: "\\f",
          10: "\\n",
          13: "\\r",
          9: "\\t"
        };

        // Internal: Converts `value` into a zero-padded string such that its
        // length is at least equal to `width`. The `width` must be <= 6.
        var leadingZeroes = "000000";
        var toPaddedString = function (width, value) {
          // The `|| 0` expression is necessary to work around a bug in
          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
          return (leadingZeroes + (value || 0)).slice(-width);
        };

        // Internal: Serializes a date object.
        var serializeDate = function (value) {
          var getData, year, month, date, time, hours, minutes, seconds, milliseconds;
          // Define additional utility methods if the `Date` methods are buggy.
          if (!isExtended) {
            var floor = Math.floor;
            // A mapping between the months of the year and the number of days between
            // January 1st and the first of the respective month.
            var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
            // Internal: Calculates the number of days between the Unix epoch and the
            // first day of the given month.
            var getDay = function (year, month) {
              return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
            };
            getData = function (value) {
              // Manually compute the year, month, date, hours, minutes,
              // seconds, and milliseconds if the `getUTC*` methods are
              // buggy. Adapted from @Yaffle's `date-shim` project.
              date = floor(value / 864e5);
              for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
              for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
              date = 1 + date - getDay(year, month);
              // The `time` value specifies the time within the day (see ES
              // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
              // to compute `A modulo B`, as the `%` operator does not
              // correspond to the `modulo` operation for negative numbers.
              time = (value % 864e5 + 864e5) % 864e5;
              // The hours, minutes, seconds, and milliseconds are obtained by
              // decomposing the time within the day. See section 15.9.1.10.
              hours = floor(time / 36e5) % 24;
              minutes = floor(time / 6e4) % 60;
              seconds = floor(time / 1e3) % 60;
              milliseconds = time % 1e3;
            };
          } else {
            getData = function (value) {
              year = value.getUTCFullYear();
              month = value.getUTCMonth();
              date = value.getUTCDate();
              hours = value.getUTCHours();
              minutes = value.getUTCMinutes();
              seconds = value.getUTCSeconds();
              milliseconds = value.getUTCMilliseconds();
            };
          }
          serializeDate = function (value) {
            if (value > -1 / 0 && value < 1 / 0) {
              // Dates are serialized according to the `Date#toJSON` method
              // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
              // for the ISO 8601 date time string format.
              getData(value);
              // Serialize extended years correctly.
              value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
              "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
              // Months, dates, hours, minutes, and seconds should have two
              // digits; milliseconds should have three.
              "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
              // Milliseconds are optional in ES 5.0, but required in 5.1.
              "." + toPaddedString(3, milliseconds) + "Z";
              year = month = date = hours = minutes = seconds = milliseconds = null;
            } else {
              value = null;
            }
            return value;
          };
          return serializeDate(value);
        };

        // For environments with `JSON.stringify` but buggy date serialization,
        // we override the native `Date#toJSON` implementation with a
        // spec-compliant one.
        if (has("json-stringify") && !has("date-serialization")) {
          // Internal: the `Date#toJSON` implementation used to override the native one.
          function dateToJSON (key) {
            return serializeDate(this);
          }

          // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
          var nativeStringify = exports.stringify;
          exports.stringify = function (source, filter, width) {
            var nativeToJSON = Date.prototype.toJSON;
            Date.prototype.toJSON = dateToJSON;
            var result = nativeStringify(source, filter, width);
            Date.prototype.toJSON = nativeToJSON;
            return result;
          }
        } else {
          // Internal: Double-quotes a string `value`, replacing all ASCII control
          // characters (characters with code unit values between 0 and 31) with
          // their escaped equivalents. This is an implementation of the
          // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
          var unicodePrefix = "\\u00";
          var escapeChar = function (character) {
            var charCode = character.charCodeAt(0), escaped = Escapes[charCode];
            if (escaped) {
              return escaped;
            }
            return unicodePrefix + toPaddedString(2, charCode.toString(16));
          };
          var reEscape = /[\x00-\x1f\x22\x5c]/g;
          var quote = function (value) {
            reEscape.lastIndex = 0;
            return '"' +
              (
                reEscape.test(value)
                  ? value.replace(reEscape, escapeChar)
                  : value
              ) +
              '"';
          };

          // Internal: Recursively serializes an object. Implements the
          // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
          var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
            var value, type, className, results, element, index, length, prefix, result;
            attempt(function () {
              // Necessary for host object support.
              value = object[property];
            });
            if (typeof value == "object" && value) {
              if (value.getUTCFullYear && getClass.call(value) == dateClass && value.toJSON === Date.prototype.toJSON) {
                value = serializeDate(value);
              } else if (typeof value.toJSON == "function") {
                value = value.toJSON(property);
              }
            }
            if (callback) {
              // If a replacement function was provided, call it to obtain the value
              // for serialization.
              value = callback.call(object, property, value);
            }
            // Exit early if value is `undefined` or `null`.
            if (value == undefined) {
              return value === undefined ? value : "null";
            }
            type = typeof value;
            // Only call `getClass` if the value is an object.
            if (type == "object") {
              className = getClass.call(value);
            }
            switch (className || type) {
              case "boolean":
              case booleanClass:
                // Booleans are represented literally.
                return "" + value;
              case "number":
              case numberClass:
                // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
                // `"null"`.
                return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
              case "string":
              case stringClass:
                // Strings are double-quoted and escaped.
                return quote("" + value);
            }
            // Recursively serialize objects and arrays.
            if (typeof value == "object") {
              // Check for cyclic structures. This is a linear search; performance
              // is inversely proportional to the number of unique nested objects.
              for (length = stack.length; length--;) {
                if (stack[length] === value) {
                  // Cyclic structures cannot be serialized by `JSON.stringify`.
                  throw TypeError();
                }
              }
              // Add the object to the stack of traversed objects.
              stack.push(value);
              results = [];
              // Save the current indentation level and indent one additional level.
              prefix = indentation;
              indentation += whitespace;
              if (className == arrayClass) {
                // Recursively serialize array elements.
                for (index = 0, length = value.length; index < length; index++) {
                  element = serialize(index, value, callback, properties, whitespace, indentation, stack);
                  results.push(element === undefined ? "null" : element);
                }
                result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
              } else {
                // Recursively serialize object members. Members are selected from
                // either a user-specified list of property names, or the object
                // itself.
                forOwn(properties || value, function (property) {
                  var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
                  if (element !== undefined) {
                    // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
                    // is not the empty string, let `member` {quote(property) + ":"}
                    // be the concatenation of `member` and the `space` character."
                    // The "`space` character" refers to the literal space
                    // character, not the `space` {width} argument provided to
                    // `JSON.stringify`.
                    results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
                  }
                });
                result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
              }
              // Remove the object from the traversed object stack.
              stack.pop();
              return result;
            }
          };

          // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
          exports.stringify = function (source, filter, width) {
            var whitespace, callback, properties, className;
            if (objectTypes[typeof filter] && filter) {
              className = getClass.call(filter);
              if (className == functionClass) {
                callback = filter;
              } else if (className == arrayClass) {
                // Convert the property names array into a makeshift set.
                properties = {};
                for (var index = 0, length = filter.length, value; index < length;) {
                  value = filter[index++];
                  className = getClass.call(value);
                  if (className == "[object String]" || className == "[object Number]") {
                    properties[value] = 1;
                  }
                }
              }
            }
            if (width) {
              className = getClass.call(width);
              if (className == numberClass) {
                // Convert the `width` to an integer and create a string containing
                // `width` number of space characters.
                if ((width -= width % 1) > 0) {
                  if (width > 10) {
                    width = 10;
                  }
                  for (whitespace = ""; whitespace.length < width;) {
                    whitespace += " ";
                  }
                }
              } else if (className == stringClass) {
                whitespace = width.length <= 10 ? width : width.slice(0, 10);
              }
            }
            // Opera <= 7.54u2 discards the values associated with empty string keys
            // (`""`) only if they are used directly within an object member list
            // (e.g., `!("" in { "": 1})`).
            return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
          };
        }
      }

      // Public: Parses a JSON source string.
      if (!has("json-parse")) {
        var fromCharCode = String.fromCharCode;

        // Internal: A map of escaped control characters and their unescaped
        // equivalents.
        var Unescapes = {
          92: "\\",
          34: '"',
          47: "/",
          98: "\b",
          116: "\t",
          110: "\n",
          102: "\f",
          114: "\r"
        };

        // Internal: Stores the parser state.
        var Index, Source;

        // Internal: Resets the parser state and throws a `SyntaxError`.
        var abort = function () {
          Index = Source = null;
          throw SyntaxError();
        };

        // Internal: Returns the next token, or `"$"` if the parser has reached
        // the end of the source string. A token may be a string, number, `null`
        // literal, or Boolean literal.
        var lex = function () {
          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
          while (Index < length) {
            charCode = source.charCodeAt(Index);
            switch (charCode) {
              case 9: case 10: case 13: case 32:
                // Skip whitespace tokens, including tabs, carriage returns, line
                // feeds, and space characters.
                Index++;
                break;
              case 123: case 125: case 91: case 93: case 58: case 44:
                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
                // the current position.
                value = charIndexBuggy ? source.charAt(Index) : source[Index];
                Index++;
                return value;
              case 34:
                // `"` delimits a JSON string; advance to the next character and
                // begin parsing the string. String tokens are prefixed with the
                // sentinel `@` character to distinguish them from punctuators and
                // end-of-string tokens.
                for (value = "@", Index++; Index < length;) {
                  charCode = source.charCodeAt(Index);
                  if (charCode < 32) {
                    // Unescaped ASCII control characters (those with a code unit
                    // less than the space character) are not permitted.
                    abort();
                  } else if (charCode == 92) {
                    // A reverse solidus (`\`) marks the beginning of an escaped
                    // control character (including `"`, `\`, and `/`) or Unicode
                    // escape sequence.
                    charCode = source.charCodeAt(++Index);
                    switch (charCode) {
                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
                        // Revive escaped control characters.
                        value += Unescapes[charCode];
                        Index++;
                        break;
                      case 117:
                        // `\u` marks the beginning of a Unicode escape sequence.
                        // Advance to the first character and validate the
                        // four-digit code point.
                        begin = ++Index;
                        for (position = Index + 4; Index < position; Index++) {
                          charCode = source.charCodeAt(Index);
                          // A valid sequence comprises four hexdigits (case-
                          // insensitive) that form a single hexadecimal value.
                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
                            // Invalid Unicode escape sequence.
                            abort();
                          }
                        }
                        // Revive the escaped character.
                        value += fromCharCode("0x" + source.slice(begin, Index));
                        break;
                      default:
                        // Invalid escape sequence.
                        abort();
                    }
                  } else {
                    if (charCode == 34) {
                      // An unescaped double-quote character marks the end of the
                      // string.
                      break;
                    }
                    charCode = source.charCodeAt(Index);
                    begin = Index;
                    // Optimize for the common case where a string is valid.
                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
                      charCode = source.charCodeAt(++Index);
                    }
                    // Append the string as-is.
                    value += source.slice(begin, Index);
                  }
                }
                if (source.charCodeAt(Index) == 34) {
                  // Advance to the next character and return the revived string.
                  Index++;
                  return value;
                }
                // Unterminated string.
                abort();
              default:
                // Parse numbers and literals.
                begin = Index;
                // Advance past the negative sign, if one is specified.
                if (charCode == 45) {
                  isSigned = true;
                  charCode = source.charCodeAt(++Index);
                }
                // Parse an integer or floating-point value.
                if (charCode >= 48 && charCode <= 57) {
                  // Leading zeroes are interpreted as octal literals.
                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
                    // Illegal octal literal.
                    abort();
                  }
                  isSigned = false;
                  // Parse the integer component.
                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
                  // Floats cannot contain a leading decimal point; however, this
                  // case is already accounted for by the parser.
                  if (source.charCodeAt(Index) == 46) {
                    position = ++Index;
                    // Parse the decimal component.
                    for (; position < length; position++) {
                      charCode = source.charCodeAt(position);
                      if (charCode < 48 || charCode > 57) {
                        break;
                      }
                    }
                    if (position == Index) {
                      // Illegal trailing decimal.
                      abort();
                    }
                    Index = position;
                  }
                  // Parse exponents. The `e` denoting the exponent is
                  // case-insensitive.
                  charCode = source.charCodeAt(Index);
                  if (charCode == 101 || charCode == 69) {
                    charCode = source.charCodeAt(++Index);
                    // Skip past the sign following the exponent, if one is
                    // specified.
                    if (charCode == 43 || charCode == 45) {
                      Index++;
                    }
                    // Parse the exponential component.
                    for (position = Index; position < length; position++) {
                      charCode = source.charCodeAt(position);
                      if (charCode < 48 || charCode > 57) {
                        break;
                      }
                    }
                    if (position == Index) {
                      // Illegal empty exponent.
                      abort();
                    }
                    Index = position;
                  }
                  // Coerce the parsed value to a JavaScript number.
                  return +source.slice(begin, Index);
                }
                // A negative sign may only precede numbers.
                if (isSigned) {
                  abort();
                }
                // `true`, `false`, and `null` literals.
                var temp = source.slice(Index, Index + 4);
                if (temp == "true") {
                  Index += 4;
                  return true;
                } else if (temp == "fals" && source.charCodeAt(Index + 4 ) == 101) {
                  Index += 5;
                  return false;
                } else if (temp == "null") {
                  Index += 4;
                  return null;
                }
                // Unrecognized token.
                abort();
            }
          }
          // Return the sentinel `$` character if the parser has reached the end
          // of the source string.
          return "$";
        };

        // Internal: Parses a JSON `value` token.
        var get = function (value) {
          var results, hasMembers;
          if (value == "$") {
            // Unexpected end of input.
            abort();
          }
          if (typeof value == "string") {
            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
              // Remove the sentinel `@` character.
              return value.slice(1);
            }
            // Parse object and array literals.
            if (value == "[") {
              // Parses a JSON array, returning a new JavaScript array.
              results = [];
              for (;;) {
                value = lex();
                // A closing square bracket marks the end of the array literal.
                if (value == "]") {
                  break;
                }
                // If the array literal contains elements, the current token
                // should be a comma separating the previous element from the
                // next.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "]") {
                      // Unexpected trailing `,` in array literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each array element.
                    abort();
                  }
                } else {
                  hasMembers = true;
                }
                // Elisions and leading commas are not permitted.
                if (value == ",") {
                  abort();
                }
                results.push(get(value));
              }
              return results;
            } else if (value == "{") {
              // Parses a JSON object, returning a new JavaScript object.
              results = {};
              for (;;) {
                value = lex();
                // A closing curly brace marks the end of the object literal.
                if (value == "}") {
                  break;
                }
                // If the object literal contains members, the current token
                // should be a comma separator.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "}") {
                      // Unexpected trailing `,` in object literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each object member.
                    abort();
                  }
                } else {
                  hasMembers = true;
                }
                // Leading commas are not permitted, object property names must be
                // double-quoted strings, and a `:` must separate each property
                // name and value.
                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
                  abort();
                }
                results[value.slice(1)] = get(lex());
              }
              return results;
            }
            // Unexpected token encountered.
            abort();
          }
          return value;
        };

        // Internal: Updates a traversed object member.
        var update = function (source, property, callback) {
          var element = walk(source, property, callback);
          if (element === undefined) {
            delete source[property];
          } else {
            source[property] = element;
          }
        };

        // Internal: Recursively traverses a parsed JSON object, invoking the
        // `callback` function for each value. This is an implementation of the
        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
        var walk = function (source, property, callback) {
          var value = source[property], length;
          if (typeof value == "object" && value) {
            // `forOwn` can't be used to traverse an array in Opera <= 8.54
            // because its `Object#hasOwnProperty` implementation returns `false`
            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
            if (getClass.call(value) == arrayClass) {
              for (length = value.length; length--;) {
                update(getClass, forOwn, value, length, callback);
              }
            } else {
              forOwn(value, function (property) {
                update(value, property, callback);
              });
            }
          }
          return callback.call(source, property, value);
        };

        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
        exports.parse = function (source, callback) {
          var result, value;
          Index = 0;
          Source = "" + source;
          result = get(lex());
          // If a JSON string contains multiple tokens, it is invalid.
          if (lex() != "$") {
            abort();
          }
          // Reset the parser state.
          Index = Source = null;
          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
        };
      }
    }

    exports.runInContext = runInContext;
    return exports;
  }

  if (freeExports && !isLoader) {
    // Export for CommonJS environments.
    runInContext(root, freeExports);
  } else {
    // Export for web browsers and JavaScript engines.
    var nativeJSON = root.JSON,
        previousJSON = root.JSON3,
        isRestored = false;

    var JSON3 = runInContext(root, (root.JSON3 = {
      // Public: Restores the original value of the global `JSON` object and
      // returns a reference to the `JSON3` object.
      "noConflict": function () {
        if (!isRestored) {
          isRestored = true;
          root.JSON = nativeJSON;
          root.JSON3 = previousJSON;
          nativeJSON = previousJSON = null;
        }
        return JSON3;
      }
    }));

    root.JSON = {
      "parse": JSON3.parse,
      "stringify": JSON3.stringify
    };
  }

  // Export for asynchronous module loaders.
  if (isLoader) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return JSON3;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)(module), __webpack_require__(4)))

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(14);


var globalNS = (function() {
  // the only reliable means to get the global object is
  // `Function('return this')()`
  // However, this causes CSP violations in Chrome apps.
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  throw new Error('unable to locate global object');
})();

if (!globalNS.Promise) {
  globalNS.Promise = __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */];
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = function(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      return constructor.resolve(callback()).then(function() {
        return constructor.reject(reason);
      });
    }
  );
};

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Promise);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6).setImmediate))

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export optim_ev */
var optim_ev = /** @class */ (function () {
    function optim_ev() {
        var _this = this;
        this.firstScroll = true;
        this.throttling = false;
        /**
         * scroll event handler
         */
        this.onScroll = function (e) {
            _this.distDiff = _this.position - window.pageYOffset;
            if (_this.firstScroll) {
                _this.throtDelay = 30;
                _this.position = window.pageYOffset;
                _this.firstScroll = false;
                _this.scrollStartTimer = setTimeout(function () {
                    if (_this.distDiff) {
                        _this.direction();
                        RFE.triggerCustomEvent(window, 'scrollStartRfe', { detail: { downDirection: _this.down, pageYOffset: _this.position } });
                    }
                }, 30);
            }
            else {
                _this.throtDelay = 300;
            }
            if (!_this.throttling) {
                _this.throttling = true;
                _this.throtTimer = setTimeout(function () {
                    _this.position = window.pageYOffset;
                    if (_this.distDiff) {
                        _this.direction();
                        RFE.triggerCustomEvent(window, 'scrollThrotleRfe', { detail: { downDirection: _this.down, pageYOffset: _this.position } });
                    }
                    _this.throttling = false;
                }, _this.throtDelay);
            }
            clearTimeout(_this.scrollEndTimer);
            _this.scrollEndTimer = setTimeout(function () {
                _this.scrollEnd();
            }, 60);
        };
        /**
         * triggered when scrolling ends
         */
        this.scrollEnd = function () {
            _this.position = window.pageYOffset;
            _this.firstScroll = true;
            _this.direction();
            RFE.triggerCustomEvent(window, 'scrollEndRfe', { detail: { downDirection: _this.down, pageYOffset: _this.position } });
        };
        /**
         * decides which way the scroll happened vertically and sets this.down
         */
        this.direction = function () {
            if (_this.distDiff < 0) {
                _this.down = true;
            }
            else {
                _this.down = false;
            }
        };
    }
    /**
     * Initialization of module. This module is expected to be used as single instance on page.
     * @return  {boolean}      TRUE/FALSE if the initialization was successful or not (boolean)
     */
    optim_ev.prototype.initGlobal = function () {
        var _this = this;
        setTimeout(function () {
            _this.position = window.pageYOffset;
            window.addEventListener('scroll', _this.onScroll);
        }, 0);
    };
    /**
     * De-initialization of module
     */
    optim_ev.prototype.deinitGlobal = function () {
        window.removeEventListener('scroll', this.onScroll);
        clearTimeout(this.scrollEndTimer);
        clearTimeout(this.scrollStartTimer);
        clearTimeout(this.throtTimer);
    };
    return optim_ev;
}());

var optimEvs = new optim_ev();
/* harmony default export */ __webpack_exports__["a"] = (optimEvs);


/***/ }),
/* 19 */
/***/ (function(module, exports) {

;
"use strict";

//register of all initialised modules
RFE.moduleRegister = [];

/**
 * Logs errors
 * @param {String} msg Message to log
 * @returns {RFE.Module} or {undefined} if not found
 */
RFE.moduleByName = function (name) {
    //run all RFE modules
    for (var i = 0; i < RFE.moduleRegister.length; i++) {
        var module = RFE.moduleRegister[i];

        //lazy load for modules
        if (module.name === name) {
            return module;
        }
    }
}

/**
 * main module wrapper - all page javascripts should be wrapped by this structure
 *
 * Usage:
 *
 *    RFE.Module.extend({
*       loadable: true,        //load once it's ready
*       lazyLoadable: false,   //can be also lazy-loaded
*       init: function (context, parent) {...
*/
RFE.Module = {
    /**
     * Creates a new module constructor
     */
    getConstructor: function() {

        //constructor
        return function () {
            RFE.moduleRegister.push(this);
        }
    },

    /**
     * Init module
     * @param {Object} module to be initialized
     */
    initModule: function(module) {
        //initial load for modules
        if (typeof module.init === 'function' && module.loadable) {
            try {
                module.init("load", document.body);
            } catch (e) {
                if (console) {
                    var obj = {stack: "N/A"};
                    if (Error.captureStackTrace) {
                        Error.captureStackTrace(obj, this);
                    }
                    if (console.error) {
                        console.error("error while " + module.name + " processing", e.message, obj.stack);
                    } else {
                        console.log("error while " + module.name + " processing", e.message, obj.stack);
                    }
                }
            }
        }

        return module;
    },

    /**
     * Factory
     * @param {Object} newModule object properties
     * @returns {RFE.Module}
     */
    extend: function (newModule) {
        var module = this.getConstructor();
        module.prototype = newModule;
        //new module()
        return this.initModule(new module());
    },

    /**
     * Factory - extend a module
     * @param {String} parentModuleName module to be extended
     * @param {Object} newModule object properties
     * @returns {RFE.Module}
     */
    extendCustomParent: function (parentModuleName, newModule) {

        var module = this.getConstructor();
        module.prototype = newModule;

        var parentModule = RFE.moduleByName(parentModuleName);

        if (!parentModule) {
            throw "Parent module not found"
        }

        for (var attr in parentModule) {
            //if (parentModule.hasOwnProperty(attr)) {
            if (typeof module.prototype[attr] === 'undefined') {
                module.prototype[attr] = parentModule[attr]
            };
        }

        return this.initModule(new module());
    }
};

/**
 * Find particular module
 * @param {String} name - a name given
 */
RFE.getModuleByName = function (name) {
    //run all RFE modules //TODO prepare a general function
    for (var i = 0; i < RFE.moduleRegister.length; i++) {
        var module = RFE.moduleRegister[i];

        if (module.name === name) {
            return module;
        }
    }
}


/***/ }),
/* 20 */
/***/ (function(module, exports) {

;
"use strict";

/// <summary>Renders 16:9 iframe with specified url</summary>
/// <param name="url">The &lt;iframe>url of the iframe</param>
/// <param name="linkUrl">url for fallback link, provide in case it should be different than iframe url</param>
/// <remarks>Used by External Content feature linked to key Multimedia.ExternalMultimedia.ProviderRulesJSON. It searches for first occurence of element with specified class. After processing it will rename it to something-rendered, so next call can process another element</remarks>
window.renderExternalContent = function (url, linkUrl) {
    var placeholder = $dom.get(".external-content-placeholder")[0];
    var ifr = document.createElement("iframe");
    var params = RFE.getURLParams(url);

    // to enable iframe JS API
    if (!params['enablejsapi'] || params['enablejsapi'] == 0) url = url + (url.indexOf('?') > -1 ? '&' : '?') + "enablejsapi=1";
    // to disable auto fullscreen mode on iOS
    if (RFE.isMobile.iPhone() && (!params['playsinline'] || params['playsinline'] == 0)) url = url + "&playsinline=1";

    // to add rel=0 param and id with player in a name for adobe analytics to work
    if (url.indexOf('youtube.com') > -1) {

        if (!params['rel'] || params['rel'] == 0) url = url + (url.indexOf('?') > -1 ? '&' : '?') + "rel=0";
        ifr.setAttribute("id", "player" + Math.floor((Math.random() * 10000)));
    }
    if (url.indexOf('pangeaEmbed=true') > -1) {
        var hostname;
        //find & remove protocol (http, ftp, etc.) and get hostname
        if (url.indexOf("//") > -1) {
            hostname = url.split('/')[2];
        }
        else {
            hostname = url.split('/')[0];
        }
        //find & remove port number
        hostname = hostname.split(':')[0];
        //find & remove "?"
        hostname = hostname.split('?')[0];
        //set platform type value
        var platformType = hostname != window.location.hostname ? 'cross-promo' : 'responsive';
        url = url.replace('pangeaEmbed=true', 'platformType=' + platformType);
    }

    ifr.setAttribute("src", url);
    ifr.style.width = "100%";
    ifr.style.height = (params['type']=='audio') ? "144px" : Math.round(placeholder.offsetWidth * 9 / 16) + "px";
    ifr.setAttribute("frameborder", "0");
    ifr.setAttribute("scrolling", "no");
    ifr.style.overflow = "hidden";
    ifr.setAttribute("allowfullscreen", "allowfullscreen");
    ifr.title = "external-frame";

    var href = linkUrl ? linkUrl : url;
    var link = document.createElement("a");
    link.setAttribute("href", href);
    link.setAttribute("target", "_blank");
    link.innerHTML = href;

    // ifr.appendChild(link);
    placeholder.appendChild(ifr);
    $dom.addClass(placeholder, "external-content-rendered");
    $dom.removeClass(placeholder, "external-content-placeholder");

    // calculates proper height when width has been changed (resize, orientationchange)
    window.addEventListener("resize", function() {
        ifr.style.height = (params['type']=='audio') ? "144px" : Math.round(placeholder.offsetWidth * 9 / 16) + "px";
    });
}


//
// main namespace for all RFE sweet things
window.RFE = window.RFE || {};

/**
* Its a provider of "pushed state below" see. replaceURLNoReload
*/
window.onpopstate = function (event) {
    if (event.state) { //skip on load: http://stackoverflow.com/questions/15896434/window-onpopstate-on-page-load
        location.href = location.href;
    };
};

/**
* Result current media query shortcut ("XS"/"SM"/"ME"/"LG")
*/
RFE.getResponsiveState = function getResponsiveState(url) {
    var responsiveIndicator = document.querySelector('.responsive-indicator');
    if ($dom.style(responsiveIndicator.querySelector('.visible-xs-block'), "display") === "block") {
        return "xs";
    } else if ($dom.style(responsiveIndicator.querySelector('.visible-sm-block'), "display") === "block") {
        return "sm";
    } else if ($dom.style(responsiveIndicator.querySelector('.visible-md-block'), "display") === "block") {
        return "md";
    } else if ($dom.style(responsiveIndicator.querySelector('.visible-lg-block'), "display") === "block") {
        return "lg";
    };
}

    /**
    * Change whole URL if possible without reloading
    */
RFE.replaceURLNoReload = function replaceURLNoReload(url) {

if (history && history.pushState) {
    history.pushState({}, "b", url);
}
}

    /**
    * Get position on the page
    */
    RFE.getOffsetFromBody = function getOffset(object, offset) {
        if (!offset) {
            offset = {x: 0, y: 0};
        }

        if (object) {
            offset.x += object.offsetLeft;
            offset.y += object.offsetTop;

            getOffset(object.offsetParent, offset);
        }

        return offset;
    }

//
// Detect mobile browsers -- http://www.abeautifulsite.net/detecting-mobile-devices-with-javascript/
RFE.isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i) && !RFE.isMobile.Windows();
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return (navigator.userAgent.match(/iPhone|iPad|iPod/i) && !RFE.isMobile.Windows())
        // navigato.platform is deprecated, BUT should solve the New iPad nonsense
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    },
    iPhone: function () {
        return navigator.userAgent.match(/iPhone/i) && !RFE.isMobile.Windows();
    },
    iPad: function () {
        return (navigator.userAgent.match(/iPad/i) && !RFE.isMobile.Windows())
        // navigato.platform is deprecated, BUT should solve the New iPad nonsense
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    },
    iPod: function () {
        return navigator.userAgent.match(/iPod/i) && !RFE.isMobile.Windows();
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () { // be careful, IEMobile send also other signatures (iOS + Android)
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (RFE.isMobile.Android() || RFE.isMobile.BlackBerry() || RFE.isMobile.iOS() || RFE.isMobile.Opera() || RFE.isMobile.Windows());
    }
};

RFE.getStyle = function (el, styleProp) {
    if (el.currentStyle)
        var y = el.currentStyle[styleProp];
    else if (window.getComputedStyle)
        var y = document.defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
    return y;
}

RFE.getURL = function () {
    return document.location;
}

/**
* Retuns Object(key-value) of URL params
*/
RFE.getURLParams = function(url) {
    if (!url || url == '' || url === undefined) url = window.location.href;
    if (url.indexOf("?") > -1) {
        url = url.replace("?nocache=1", "");
        var paramsStr = url.substring(url.indexOf("?") + 1);
        var params = {};

        var arr = paramsStr.split("&");
        for (var i = 0; i < arr.length; i++) {
            var paramStr = arr[i];
            if (paramStr.indexOf("=") > -1) {
                var key = paramStr.substring(0, paramStr.indexOf("="));
                var value = paramStr.substring(paramStr.indexOf("=") + 1);
                params[key] = value;
            }
        }
        return params;
    }
    return {};
}

/**
* Check if the site is RTL (returns true) or LTR (returns false)
*/
RFE.isRTL = function (el, styleProp) {
    return document.getElementsByTagName("HTML")[0].getAttribute("dir") === "rtl";
}

//
// Detect the type of RTL scroll mode - like a master here: https://github.com/othree/jquery.rtl-scroll-type
//
//3 Types of scrollLeft (scrollWidth = 100)
//
//Browser       Type        Most Left	Most Right	Initial
//WebKit        default     0           100         100
//Firefox/Opera	negative    -100        0           0
//IE            reverse     100         0           0
//

RFE.getRTLScrollType = function () {
    var definer = $dom.create('div');
    definer.dir = "rtl";
    $dom.style(definer, {
        "font-size": "14px",
        "width": "1px",
        "height": "1px",
        "position": "absolute",
        "top": "-1000px",
        "overflow": "scroll"
    });
    definer.innerHTML = "A";
    document.body.appendChild(definer);

    //style="">A</div>').appendTo('body')[0],

    var type = 'reverse';

    if (definer.scrollLeft > 0) {
        type = 'default';
    } else {
        definer.scrollLeft = 1;
        if (definer.scrollLeft === 0) {
            type = 'negative';
        }
    }

    definer.parentNode.removeChild(definer);
    return type;
}

//
// Attach Event IE8 safe variant
//
RFE.attachEvent = function (element, name, fn) {
    if (element.addEventListener) {
        element.addEventListener(name, fn, false); //allways bubbling
    } else {
        element.attachEvent("on" + name, fn);
    }
}

// Prevent default compatible with ie.
RFE.preventDefault = function (e) {
    e = e || event;
    e.preventDefault ? e.preventDefault() : e.returnValue = false;
    e.stopPropagation ? e.stopPropagation() : e.returnValue = false;
}

// Check that response is valid.
RFE.isResponseValid = function (response) {
    return response && (typeof response === "object" || response instanceof Array);
}

// adapted from matchMedia polyfill
// by Scott Jehl and Paul Irish
// gist.github.com/786768
RFE.testMediaQuery = function () {

    try {
        var mq = window.matchMedia("(min-width: 500px)");
    } catch (e) {
    }

    var matchMedia = window.matchMedia || window.msMatchMedia;
    if (matchMedia) {
        return matchMedia(mq) && matchMedia(mq).matches || false;
    }

    return false;
}

/**
* Add ECMA262-5 Array methods if not supported natively
*/
RFE.indexOf = function (arr, find, i /*opt*/) {
    if (i === undefined) i = 0;
    if (i < 0) i += arr.length;
    if (i < 0) i = 0;
    for (var n = arr.length; i < n; i++)
        if (i in arr && arr[i] === find)
            return i;
    return -1;
};

/**
 * Get elements by attribute.
 * @param {String} attribute Attribute name.
 * @param {HTMLElement} parent Element to search in - optional.
 * @param {String|Function} value Optional value which the lement have to contain.
 *   When function is passed, it's get called for each element with parameters: the attribute
 *   content and the element. When the function returns true, the element is added to the return
 *   array.
 * @returns {Array} Array of matched elements.
 */
RFE.getElementsByAttribute = function (attribute, parent, value) {
    if (typeof parent === "string" || typeof parent === "function") {
        value = parent;
        parent = null;
    }

    if (!parent) {
        parent = document;
    }

    var search = [];
    var elems = parent.getElementsByTagName("*");

    for (var i = 0; i < elems.length; i++) {
        if (!elems[i].hasAttribute(attribute)) {
            continue;
        }

        if (typeof value === "function") {
            if (!value(elems[i].getAttribute(attribute), elems[i])) {
                continue;
            }
        }
        else if (typeof value !== "undefined" && elems[i].getAttribute(attribute) != value) {
            continue;
        }

        search.push(elems[i]);
    }

    return search;
};

/**
 * Find all form data elements.
 * @param {HTMLElement} form Form or other element containing form data elements.
 * @returns {Array} Array of found elements.
 */
RFE.getFormElements = function (form) {
    var search = [];
    var elems = form.getElementsByTagName("*");

    for (var i = 0; i < elems.length; i++) {
        var tag = elems[i].tagName.toLowerCase();
        if (tag !== "input" && tag !== "select" && tag !== "textarea") {
            continue;
        }

        search.push(elems[i]);
    }

    return search;
};


/**
 * DOM aditional methods.
 */

/**
 * Production steps of ECMA-262, Edition 5, 15.4.4.18
 */
if (!Array.prototype.forEach) Array.prototype.forEach = function (callback, thisArg) {
    if (!this) throw "forEach can't be called on null.";
    if (typeof callback !== "function") throw "callback for forEach have to be a function.";

    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
        if (!this[i]) continue;
        callback.call(thisArg, this[i], i, this);
    }
};


/**
 * Asynchronously load script from remote location.
 * @param {String} src Script URL.
 * @param {Function} onload Optinal onload callbeck.
 */
window.loadScript = function (src, onload) {
    if (typeof src !== "string") throw "loadScript: src have to be a string.";

    var script = document.createElement("script");
    if (typeof onload === "function")
        script.onload = onload;

    document.head.appendChild(script);

    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", src);
}

/**
 * Create the first element in given HTML string.
 * @param {String} html HTML to create.
 * @returns {HTMLElement} Created element.
 */
window.createHTML = function (html) {
    var div = document.createElement("DIV");
    div.innerHTML = html;
    var el = div.firstChild;
    while (el) {
        if (el.nodeType === 1)
            return el;
        el = el.nextSibling;
    }
    return null;
};

/**
 * Activate JavaScripts in given element.
 */
HTMLElement.prototype.activateScripts = function () {
    var scripts = this.querySelectorAll("script");
    for (var i = 0; i < scripts.length; i++) {
        var script = document.createElement("script");
        var sc = scripts[i];

        if (sc.type) {
            script.setAttribute("type", sc.type);
        }

        if (sc.src) {
            script.setAttribute("src", sc.src);
            var data = sc.dataset;
            for (var key in data ) {
                script.dataset[key] = data[key];
            }
        }
        else {
            script.text = sc.text;
        }

        var p = sc.parentNode;
        p.insertBefore(script, sc);
        p.removeChild(sc);
    }
};

/**
 * Collect current form data, which should be sent.
 * @returns {Object} Form data.
 */
HTMLFormElement.prototype.getActionData = function (useFormData) {
    if (useFormData) {
        return new FormData(this);
    }

    var elems = this.querySelectorAll("input, select, textarea");
    var data = {};

    for (var i = 0; i < elems.length; i++) {
        var el = elems[i];
        var val = null;

        if (!el.name || el.disabled)
            continue;

        switch (el.tagName.toLowerCase()) {
            case "input":
                switch (el.type) {
                    case "hidden":
                        val = data[el.name] ? data[el.name] : el.value;
                        break;
                    case "radio":
                    case "checkbox":
                        if (!el.checked) continue;
                    default:
                        val = el.value;
                }
                break;

            case "select":
                var item = el.options[el.selectedIndex];
                if (!item) continue;
                val = item.value || item.text;
                break;

            case "textarea":
                val = el.value;
                break;
        }

        data[el.name] = val;
    }

    return data;
};



/**
 * Simple AJAX functions. TODO
 */

function handleResponse(xhr, cbready, mode, readWithAnyStatus) {
    if (typeof cbready !== "function")
        throw "ajax" + mode + ": cbready must be a function!";

    xhr.onreadystatechange = function () {
        if (this.readyState !== 4) return;
        if (this.status === 200 || readWithAnyStatus)
            cbready(parseResponse(this));
        else
            cbready(null);
    };
}

function parseResponse(xhr) {
    var ct = xhr.getResponseHeader("Content-Type");
    if (ct && (/application\/json/).test(ct)) {
        try {
            return JSON.parse(xhr.responseText);
        }
        catch(err) {
            return xhr.responseText;
        }
    }
    else
        return xhr.responseText;
}

function parseData(data) {


    if (typeof FormData !== "undefined" && data instanceof FormData) {
        return data;
    }

    function parseDataNode(name, object, encoded) {
        var ename = encoded ? name : encodeURIComponent(name);
        var param = "";

        function couple(string, encode) {
            return ename + "=" + (encode ? encodeURIComponent(string) : string);
        }

        // %5B .. [
        // %5D .. ]
        switch (typeof object) {
            case "boolean":
                param = couple(object ? "1" : "0");
                break;
            case "undefined":
                param = couple("0");
                break;
            case "number":
                param = couple(object);
                break;
            case "string":
                param = couple(object, true);
                break;
            case "object":
                if (!object)
                    param = couple("0");
                else {
                    var objects = [];
                    if (Array.isArray(object)) {
                        for (var i = 0; i < object.length; i++)
                            objects.push(parseDataNode(ename + "%5B" + i + "%5D", object[i], true));
                    }
                    else {
                        for (var i in object) {
                            if (object.hasOwnProperty(i))
                                object.push(parseDataNode(ename + "%5B" + encodeURIComponent(i) + "%5D", object[i], true));
                        }
                    }

                    param = object.join('&');
                }
        }

        return param;
    }

    var cnt = 0, toSend = "";
    for (var i in data) {
        if (data.hasOwnProperty(i)) {
            if (cnt++ > 0) toSend += "&";
            toSend += parseDataNode(i, data[i]);
        }
    }

    return toSend;
}

/**
 * Check whether the code is invoked inside CMS
 * - the check is based on the presence of base element
 *
 * TODO - remove this functionality, this check should not be called at all.
 *   This is just hotfix for https://jira.pangea-cms.com/browse/PANGEA-6362
 *
 * @returns {Boolean} is inside CMS?
 */
window.isInsideCms = function () {
    var base = document.getElementsByTagName('base');
    return base && base.length > 0;
}

/**
 * Create GET ajax request.
 * @param {String} url Request URL.
 * @param {Object} data Optional data which are serialized at the end of the URL. This parameter can be omitted.
 * @param {Function|Boolean} cbready When passed true, the request is made
 *   synchronously. Otherwise an instance of Function is required. The parameter of
 *   the response is null when the response status is different than 200 OK, when
 *   the response has Content-Type set to application/json the content is parsed and
 *   returned as Object. Otherwise the text content is set.
 * @param {?Object} xhrOptions when passed, all the attributes are set to the xhr object
 * @returns {XMLHttpRequest|Object|String} When the cbready is set as an instance of Function,
 *   XMLHttpRequest is returned. Otherwise the response is parsed the same way as the argument
 *   of the Function which could be passed.
 */
window.ajaxGet = function (url, data, cbready, xhrOptions) {
    if (cbready === undefined) {
        cbready = data;
        data = null;
    }
    else {
        var strdata = parseData(data);
        if (strdata.length > 0) {
            url += (url.indexOf("?") >= 0) ? "&" : "?";
            url += strdata;
        }
    }

    var sync = true;
    if (cbready !== true) sync = false;

    var xhr = new XMLHttpRequest();
    xhr.open("GET", url.split('#')[0], !sync);

    if (!sync) handleResponse(xhr, cbready, "Get");
    if (typeof xhrOptions === "object") {
        for (var i in xhrOptions) {
            xhr[i] = xhrOptions[i];
        }
    }
    if (!isInsideCms()) {
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    }
    xhr.send();

    return sync ? parseResponse(xhr) : xhr;
}


/**
 * Create POST ajax request.
 * @param {String} url Request URL.
 * @param {Object} data Data to POST.
 * @param {Function|Boolean} cbready When passed true, the request is made
 *   synchronously. Otherwise an instance of Function is required. The parameter of
 *   the response is null when the response status is different than 200 OK, when
 *   the response has Content-Type set to application/json the content is parsed and
 *   returned as Object. Otherwise the text content is set.
 * @param {Function} cbstart When set this call is called before XHR is sent.
 * @param {?Object} options addition options.
 *  if options contains an object xhrOptions, all the attributes are set to the xhr object
 *  if options contains a boolean withAnyStatus property, XMLHttpRequest response will be handled with any status code
 * @returns {XMLHttpRequest|Object|String} When the cbready is set as an instance of Function,
 *   XMLHttpRequest is returned. Otherwise the response is parsed the same way as the argument
 *   of the Function which could be passed.
 */
window.ajaxPost = function (url, data, cbready, cbstart, options) {
    var sync = true;
    if (cbready !== true) sync = false;

    var xhr = new XMLHttpRequest();
    if (typeof cbstart === "function") {
        var ret = cbstart(xhr);
        if (ret === false) {
            return false;
        }
    }

    xhr.open("POST", url.split('#')[0], !sync);

    var withAnyStatus = options && options.withAnyStatus;

    if (!sync) {
        handleResponse(xhr, cbready, "Post", withAnyStatus);
    }

    if ((typeof FormData !== "undefined")  &&  (!(data instanceof FormData))) {
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    }
    if (!sync) handleResponse(xhr, cbready, "Post", withAnyStatus);

    if (!isInsideCms()) {
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    }
    if (options) {
        var xhrOptions = options.xhrOptions;
        if (typeof xhrOptions === "object") {
            for (var i in xhrOptions) {
                xhr[i] = xhrOptions[i];
            }
        }
    }
    xhr.send(parseData(data));

    return sync ? parseResponse(xhr) : xhr;
}

/**
 * Create URI from root directory.
 * @param {String} uri Website URI.
 * @returns {String} Full URI.
 */
window.root = function (uri) {
    uri = uri || "";
    if (uri.length > 0 && uri.charAt(0) === "/")
        uri = uri.substr(1);
    return appBaseUrl + uri;
};

RFE.createCookie = function(name, value, days, domain) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    }
    else var expires = "";
    var domainStr = domain ? "; domain=" + domain : "";
    document.cookie = name + "=" + value + expires + domainStr + "; path=/; secure";
}

RFE.readCookie = function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

RFE.eraseCookie = function(name, domain) {
    RFE.createCookie(name, "", -1, domain);
}

/**
 * Include CSS from file stored on server
 * @param {String} fileName file name on the server
 */
RFE.loadCSS = function(fileName) {
    var el = document.createElement("link");
    var path = appBaseUrl + "Content/responsive/" + fileName + ".css?cb=" + cacheBuster;
    el.setAttribute("rel", "stylesheet");
    el.setAttribute("href", path);
   document.body.appendChild(el);
}

/**
 * Include font from server font folder dynamicaly by JS
 * @param {String} fontName font family name
 * @param {String} fileName file name on the server
 * @param {?String} fontWeight optional font weight
 */
RFE.loadFont = function(fontName, fileName, fontWeight) {
    var el = document.createElement("style");
    var path = appBaseUrl + "Content/responsive/fonts/" + fileName;
    fontWeight = typeof fontWeight === "undefined" ? "normal" : fontWeight;
    el.setAttribute("type", "text/css");
    el.innerHTML = "@font-face {"
        + "font-family: \"" + fontName + "\";"
        + "src: url('" + path + ".woff2') format('woff2'), url('" + path + ".woff') format('woff');"
        + "font-weight: " + fontWeight + ";"
        + "font-style: normal;"
   + "}";
   document.body.appendChild(el);
}

/**
 * Add an event listener
 * @param {HTMLElement} el DOM element
 * @param {String} eventName name of custom event
 * @param {Function} handler function which will be triggered
 */
RFE.addCustomEventListener = function(el, eventName, handler) {
    if (el.addEventListener) {
        el.addEventListener(eventName, handler);
    } else {
        el.attachEvent('on' + eventName, function() {
            handler.call(el);
        });
    }
}

/**
 * Trigger the event
 * @param {HTMLElement} el DOM element
 * @param {String} eventName name of event which should be triggered
 * @param {customEventInit} customEventInit options
 */
RFE.triggerCustomEvent = function(el, eventName, options) {
    var event;

    var CustomEvIsSupported = (function () {
        try {
            new CustomEvent('test');
            return true;
        } catch (e) {
            return false;
        }
    })();

    if (window.CustomEvent && CustomEvIsSupported) {
        event = new CustomEvent(eventName, options);
    } else {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventName, true, true, options);
    }
    el.dispatchEvent(event);
}

var MutationObserver = window.MutationObserver || window.WebKitMutationObserver,
    eventListenerSupported = window.addEventListener;

/**
 * Register event, that is triggered after the dom is changed
 * @param {HTMLElement} obj DOM element to be observed
 * @param {function} callback triggered after the dom of the element was changed
 */
RFE.observeDOM = function(obj, callback){
    var obs;
    if( MutationObserver ){
        // define a new observer
        obs = new MutationObserver(function(mutations, observer){
            var doCallback = false;
            for (var i = 0; i < mutations.length; i++) {
                doCallback = doCallback || mutations[i].addedNodes.length || mutations[i].removedNodes.length;
            }
            if (doCallback) {
                callback();
            }
        });
        // have the observer observe foo for changes in children
        obs.observe( obj, {
            attributes: true,
            childList:true,
            characterData: true,
            subtree: true
        });
    }
    else if( eventListenerSupported ){
        obj.addEventListener('DOMNodeInserted', callback, false);
        obj.addEventListener('DOMNodeRemoved', callback, false);
    }

    return function() {
        if( MutationObserver && obs ){
            obs.disconnect();
        }
        else if( eventListenerSupported ){
            obj.removeEventListener('DOMNodeInserted', callback, false);
            obj.removeEventListener('DOMNodeRemoved', callback, false);
        }
    }
}

RFE.parseQueryString = function(query) {
    var vars = query.split("&");
    var qs = {};
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (typeof qs[pair[0]] === "undefined") {
            qs[pair[0]] = decodeURIComponent(pair[1]);
        }
        else if (typeof qs[pair[0]] === "string") {
            var arr = [qs[pair[0]], decodeURIComponent(pair[1])];
            qs[pair[0]] = arr;
        }
        else {
            qs[pair[0]].push(decodeURIComponent(pair[1]));
        }
    }
    return qs;
  }

RFE.hasClass = function (className, el) {
    /// <summary>Checks if element contains CSS class</summary>
    /// <param name="className">CSS class to look for</param>
    /// <param name="el">Element to check</param>
    return (el.classList) ? el.classList.contains(className) : new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
}
RFE.addClass = function (className, el) {
    /// <summary>Adds CSS class to element</summary>
    /// <param name="className">CSS class to add</param>
    /// <param name="el">Element or NodeList to add CSS class to</param>
    var addClassSingle = function (el) {
        if (el.classList)
            el.classList.add(className);
        else
            el.className += ' ' + className;
    }

    if (el instanceof NodeList) {
        for (i = 0; i < el.length; ++i) {
            addClassSingle(el[i]);
        }
    } else {
        addClassSingle(el);
    }
}
RFE.removeClass = function (className, el) {
    /// <summary>Removes CSS class to element</summary>
    /// <param name="className">CSS class to remove</param>
    /// <param name="el">Element or NodeList to remove CSS class from</param>
    var removeClassSingle = function (el) {
        if (el.classList)
            el.classList.remove(className);
        else
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    if (el instanceof NodeList) {
        for (i = 0; i < el.length; ++i) {
            removeClassSingle(el[i]);
        }
    } else {
        removeClassSingle(el);
    }
}
RFE.select = function (selector, context) {
    /// <summary>Select elements by DOM selector</summary>
    /// <param name="selector">selector text</param>
    /// <param name="context">Context DOM object to select from in needed</param>
    /// <returns>List containing DOM Object(s)</summary>
    return (context || document).querySelectorAll(selector);
}
RFE.filter = function (array, fcn) {
    /// <summary>filters array by applying given function to each item</summary>
    /// <param name="array">array to filter</param>
    /// <param name="fcn">function to check each array item against</param>
    /// <remarks>Function must return value which can be interpreted as boolean</remarks>
    /// <returns>filtered array</summary>
    if (!Array.prototype.filter) {
        Array.prototype.filter = function (fun) {
            var len = this.length >>> 0;
            var res = [];
            var thisp = arguments[1];
            for (var i = 0; i < len; i++) {
                if (i in this) {
                    var val = this[i];
                    if (fun.call(thisp, val, i, this))
                        res.push(val);
                }
            }
            return res;
        };
    }
    return array.filter(fcn);
}
RFE.isVisible = function (el) {
    /// <summary>Checks if DOM element is visible.</summary>
    /// <param name="el">Element to check</param>
    if (el === undefined) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
}
RFE.offset = function (el) {
    /// <summary>Computes left and top offsets of given element.</summary>
    /// <param name="el">Element to get offset for</param>
    /// <returns>Anonymous Object with left and top property</summary>
    var rect = el.getBoundingClientRect();
    return { top: rect.top + document.body.scrollTop, left: rect.left + document.body.scrollLeft };
}
RFE.position = function (el) {
    /// <summary>Computes left and top positions of given element.</summary>
    /// <param name="el">Element to get positions for</param>
    /// <returns>Anonymous Object with left and top property</summary>
    return { left: el.offsetLeft, top: el.offsetTop };
}
RFE.outerWidth = function (el) {
    /// <summary>Gets outer width with incl. margins</summary>
    /// <param name="el">Element to get outer width for</param>
    var width = el.offsetWidth;
    var style = getComputedStyle(el);
    width += parseInt(style.marginLeft) + parseInt(style.marginRight);
    return width;
}
RFE.show = function (el) {
    /// <summary>Makes element visible</summary>
    /// <param name="el">Element to get visible</param>
    if (el && el.style)
        el.style.display = 'block'; //due to IE compat. Inline elements will require separate show function if needed
}
RFE.hide = function (el) {
    /// <summary>Makes element invisible with 0 size</summary>
    /// <param name="el">Element to get invisible with 0 size</param>
    if (el && el.style)
        el.style.display = 'none';
}
RFE.data = function (el, name, value) {
    /// <summary>Gets data from data attribute</summary>
    /// <param name="el">Name of data property to obtain</param>
    /// <param name="name">Data name</param>
    /// <param name="value">Value to set to data attribute</param>
    /// <returns>Textual value fo data attribute</returns>
    if (el) {
        if (!value) {
            if (el.dataset && el.dataset[name])
                return el.dataset[name];
            else
                return el.getAttribute('data-' + name);
        } else {
            if (el.dataset)
                el.dataset[name] = value;
            else
                el.setAttribute('data-' + name, value);
        }
    } else {
        return null;
    }
}
RFE.selectParent = function (element, className) {
    /// <summary>Gets the first parent element with requested class name</summary>
    /// <param name="element">Starting element</param>
    /// <param name="className">CSS class name which is used as selector for target element</param>
    var elementsParent = false;
    var parent = (element) ? element.parentNode : false;
    if (parent) {
        do {
            if (RFE.hasClass(className, parent)) {
                elementsParent = parent;
            }
            else {
                parent = parent.parentNode;
                if (!parent)
                    return false;
            }
        }
        while (!elementsParent);
    }
    return elementsParent;
}


RFE.isChildOf = function (child, parent) {
    /// <summary>Checks if the parent is direct or indirect parentNode of child element.</summary>
    /// <param name="child">Child DOM element</param>
    /// <param name="parent">parent DOM element which should be tested if it is parent of child</param>
    if (child.parentNode === parent) {
        return true;
    } else if (child.parentNode === null) {
        return false;
    } else {
        return RFE.isChildOf(child.parentNode, parent);
    }
}

RFE.closest = function (el, sel) {
    /// <summary>Finds closest parent by selector</summary>
    /// <param name="el">Element to search parents of</param>
    /// <param name="sel">Selector to match parent</param>
    if (typeof el.closest === 'function')
        return el.closest(sel) || null;
    if (!Element.prototype.matches) //ie fix
        Element.prototype.matches = Element.prototype.msMatchesSelector;
    while (el) {
        if (el.matches(sel))
            return el;
        el = el.parentElement;
    }
    return null;
}

RFE.isDescendant = function (parent, child) {
    /// <summary>Checks if the element have given element as parent</summary>
    /// <param name="parent">Parent element to search for</param>
    /// <param name="child">Child element that has to be tested</param>
    var node = child.parentNode;
    while (node != null) {
        if (node == parent)
            return true;
        node = node.parentNode;
    }
    return false;
}

RFE.isStickyPersistent = function (el) {
    /// <summary>Checks if the element is persistent sticky (inside persistent sticky container)</summary>
    /// <param name="el">Element to check</param>
    /// <returns>Persistent sticky container or null</returns>
    return RFE.closest(el, ".stickyPersistencyPlayer");
}

/**
 * Creates a new function which is run only once within a specified time range
 * This function is typically used for groupping multiple keypress events to react to the user input after the user
 * finish his typing
 * @param {function} callback the callback function to be debounced
 * @param {number} timeout a time in milliseconds
 * @returns {function} a function with the same input arguments signature as a callback function
 */
RFE.debounce = function(callback, timeout) {
    var to = null;
    return function() {
        var fcnArguments = arguments;
        if (to) {
            window.clearTimeout(to);
            to = null;
        }
        to = window.setTimeout(function() {
            callback.apply(null, fcnArguments);
        }, timeout);
    }
}


/***/ })
],[9]);


// WEBPACK FOOTER //
// app_code.js